import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { WalletDisconnectionResourcePackage } from "../resources/WalletDisconnectionResourcePackage";
import { WalletDisconnectionPopupView } from "../views/WalletDisconnectionPopupView";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

@injectable()
export class WalletDisconnectionPopupScene extends Viewable<boolean> {
    private readonly walletDisconnectionResources: WalletDisconnectionResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly canvasScaler: ICanvasScaler;
    private readonly logger: ILogger;

    public constructor(
        walletDisconnectionResources: WalletDisconnectionResourcePackage,
        commonResources: CommonResourcesPackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        this.walletDisconnectionResources = walletDisconnectionResources;
        this.commonResources = commonResources;
        this.canvasScaler = canvasScaler;
        this.logger = logger;
    }

    @initializer()
    public async initialization(): Promise<void> {
        try {
            const pcs = new PromiseCompletionSource<boolean>();
            this.view = new WalletDisconnectionPopupView(
                pcs,
                this.canvasScaler,
                this.walletDisconnectionResources,
                this.commonResources
            );
            pcs.result.then((result) => {
                this.operationControls.complete(result);
            }, (reason: any) => {
                throw reason;
            });
        }
        catch (e: unknown) {
            this.logger.error(e);
            this.operationControls.complete(false);
        }
    }
}
